import useConditionalEffect from 'hooks/useConditionalEffect'
import { FC, ReactNode, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getDestinations } from 'services/destinations'
import { StoreThunkDispatch } from 'store/state'

export interface FetchPostDestinationsProps {
  force?: boolean
  children?: ReactNode
  onFetched?(): void
  onFailed?(err: any): void
}

const FetchPostDestinations: FC<FetchPostDestinationsProps> = ({
  force = true,
  children,
  onFetched,
  onFailed
}) => {
  const dispatch = useDispatch() as StoreThunkDispatch

  const handleFailed = useCallback((err: any) => {
    console.log(err)
    if (onFailed) {
      onFailed(err)
    }
  }, [onFailed])

  const handleFetched = useCallback(() => {
    if (onFetched) {
      onFetched()
    }
  }, [onFetched])

  const fetch = useCallback((forceFetch: boolean) => {
    return dispatch(getDestinations(forceFetch))
      .unwrap()
      .then(handleFetched)
      .catch(handleFailed)
  }, [dispatch, handleFetched, handleFailed])

  useConditionalEffect(([_fetch]) => {
    _fetch(force)
  }, [force], [fetch])

  return children || null
}

export default FetchPostDestinations
